import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getLocations, createLocation, updateLocation, deleteLocation } from "../lib/api";

const empty = { name: "", pin: "", address: "", contact: "" };

export const LocationsManager = ({ open, onClose, onChanged }) => {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = async () => setList(await getLocations());
  useEffect(() => { if (open) { load(); setForm(empty); setEditId(null); } }, [open]);
  if (!open) return null;

  const save = async (e) => {
    e.preventDefault();
    if (!form.name || !form.pin) return toast.error("Nama dan PIN wajib diisi");
    try {
      if (editId) await updateLocation(editId, form);
      else await createLocation(form);
      toast.success("Lokasi tersimpan");
      setForm(empty); setEditId(null);
      await load(); onChanged && onChanged();
    } catch { toast.error("Gagal menyimpan lokasi"); }
  };

  const onDelete = async (loc) => {
    if (!window.confirm(`Hapus lokasi "${loc.name}"? Semua pekerjaannya ikut terhapus.`)) return;
    await deleteLocation(loc.id);
    toast.success("Lokasi dihapus");
    await load(); onChanged && onChanged();
  };

  const inputCls = "w-full px-3 py-2 border border-slate-300 rounded-lg text-xs focus:ring-2 focus:ring-teal-500 outline-none";

  return (
    <div className="no-print fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl my-auto flex flex-col max-h-[92vh] animate-fade-up" data-testid="locations-modal">
        <div className="px-6 py-4 bg-gradient-to-r from-slate-900 to-teal-800 text-white flex justify-between items-center">
          <h3 className="text-base sm:text-lg font-bold flex items-center gap-2"><i className="ph-bold ph-map-pin-line text-teal-300" /> Kelola Lokasi & PIN Pelanggan</h3>
          <button onClick={onClose} className="text-slate-300 hover:text-white p-1 rounded-lg hover:bg-white/10"><i className="ph-bold ph-x text-xl" /></button>
        </div>
        <div className="p-6 overflow-y-auto space-y-5">
          <form onSubmit={save} className="bg-slate-50 p-4 rounded-xl border border-slate-200 grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label className="block text-[11px] font-semibold text-slate-600 mb-1">Nama Lokasi / Pelanggan *</label>
              <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} placeholder="mis. Toko ABC / Kantor XYZ" data-testid="loc-name" />
            </div>
            <div>
              <label className="block text-[11px] font-semibold text-slate-600 mb-1">PIN Akses *</label>
              <input value={form.pin} onChange={(e) => setForm({ ...form, pin: e.target.value })} className={inputCls} placeholder="mis. 1234" data-testid="loc-pin" />
            </div>
            <div>
              <label className="block text-[11px] font-semibold text-slate-600 mb-1">Alamat</label>
              <input value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} className={inputCls} />
            </div>
            <div>
              <label className="block text-[11px] font-semibold text-slate-600 mb-1">Kontak</label>
              <input value={form.contact} onChange={(e) => setForm({ ...form, contact: e.target.value })} className={inputCls} />
            </div>
            <div className="sm:col-span-2 flex justify-end gap-2">
              {editId && <button type="button" onClick={() => { setForm(empty); setEditId(null); }} className="px-3 py-2 border border-slate-300 text-slate-700 text-xs font-bold rounded-lg">Batal Edit</button>}
              <button type="submit" className="px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white text-xs font-bold rounded-lg" data-testid="loc-save-btn">
                {editId ? "Perbarui Lokasi" : "Tambah Lokasi"}
              </button>
            </div>
          </form>

          <div className="space-y-2">
            {list.length === 0 && <p className="text-center text-xs text-slate-400 py-4">Belum ada lokasi.</p>}
            {list.map((loc) => (
              <div key={loc.id} className="flex items-center justify-between gap-3 p-3 border border-slate-200 rounded-xl" data-testid={`loc-row-${loc.id}`}>
                <div className="min-w-0">
                  <p className="font-bold text-slate-800 text-sm truncate">{loc.name}</p>
                  <p className="text-xs text-slate-500">PIN: <span className="font-mono font-bold text-teal-700">{loc.pin}</span>{loc.address ? ` • ${loc.address}` : ""}</p>
                </div>
                <div className="flex gap-1.5 shrink-0">
                  <button onClick={() => { setForm({ name: loc.name, pin: loc.pin, address: loc.address, contact: loc.contact }); setEditId(loc.id); }} className="px-2.5 py-1.5 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg text-xs font-bold" data-testid={`loc-edit-${loc.id}`}><i className="ph-bold ph-pencil-simple" /></button>
                  <button onClick={() => onDelete(loc)} className="px-2.5 py-1.5 bg-rose-50 hover:bg-rose-100 text-rose-700 rounded-lg text-xs font-bold" data-testid={`loc-delete-${loc.id}`}><i className="ph-bold ph-trash" /></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
